import type {GetInvoicesParams, GetInvoicesModel} from 'domain/usecases';
import {makeGetInvoices} from 'main/factories/usecases';

export const getInvoices = async (params?: GetInvoicesParams): Promise<GetInvoicesModel> => {
	return makeGetInvoices().get(params);
};
